"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.from_present = void 0;
const Exp = __importStar(require("../exp"));
const Mod = __importStar(require("../mod"));
const aline_1 = require("../utils/aline");
function from_present(present) {
    const map = new Map();
    const metadata = {};
    const mod = { map, metadata };
    for (const [name, value] of Object.entries(present)) {
        if (name.startsWith("$")) {
            const key = name.slice(1);
            metadata[key] = value;
        }
        else {
            const exp = Exp.from_present(value);
            if (exp.kind === "Exp.grammar" && exp.name !== name)
                throw new Error((0, aline_1.aline)(`
             |When bind a grammar to a name,
             |the grammar name must be the same as the name.
             |- grammar name: ${exp.name}
             |- name: ${name}
             |`));
            Mod.update(mod, name, exp);
        }
    }
    return mod;
}
exports.from_present = from_present;
//# sourceMappingURL=mod-from-present.js.map